import React, { useState, createRef, useRef } from "react";
import styled from "styled-components/macro";
import { useSelector } from "react-redux";
import { RoomUnit } from "./room_unit";
import { RideUnit } from "./ride_unit";
import { AddItemToUnit } from "./AddItemToUnit/AddItemToUnitPage";
import { WizardForm } from "./wizard_form";
import { RideUnits, RidePlans } from "./ride";
import { useRideUnitContext } from "../../contexts";
import PDF from "../../pages/PDF";
import { uploadProposal } from "../utils/uploadProposal";
import { usePopulateRides } from "./hooks/usePopulateRides";
import { usePopulateItems } from "./hooks/usePopulateItems";
import { useExitPdfMode } from "./hooks/useExitPdfMode";
import { importFromFirebase } from "./hooks/importFromFirebase";
import { useHandleMonitor } from "./hooks/useHandleMonitor";
import { useSnapshot } from "valtio";
import { proposal } from "../../globalState";
import { saveProposal } from "../utils/saveProposal";
import { updateSumCosts } from "./updateSumCosts";

export const unitBoxSizes = {
  small: 75,
  medium: 158,
  large: 324,
  xl: 490,
};

const CreateUnitPageForm = ({
  columns,
  setColumns,
  rideItems,
  setRideItems,
}) => {
  const { items, templates } = useSelector(mapStateToProps);
  const [itemsCount, setItemsCount] = useState({});
  const [logoImage, setLogoImage] = useState(null);
  const [roomSimulationImage, setRoomSimulationImage] = useState(null);
  const [roomSimulationImageDesc, setRoomSimulationImageDesc] = useState(null);
  const [rideSimulationImage, setRideSimulationImage] = useState(null);
  const [rideSimulationImageDesc, setRideSimulationImageDesc] = useState(null);
  const [colorUnit, setColorUnit] = useState(
    "linear-gradient(to bottom, #f7f7f7, #f1efef)"
  );
  const unitWrapperRef = createRef();

  const [open, setOpen] = useState(null);
  const [link, setLink] = useState();
  const [showAddColumnOnHover, setShowAddColumnOnHover] = useState(-1);
  const [location, setLocation] = useState("us");
  const [ownerRevenue, setOwnerRevenue] = useState(0);
  const [typeOfProperty, setTypeOfProperty] = useState();
  const [typeOfTemplate, setTypeOfTemplate] = useState();
  const [rent, setRent] = useState(true);
  const [shop, setShop] = useState(true);
  const [ride, setRide] = useState(true);
  const [hideIntroduction, setHideIntroduction] = useState(false);
  const [separatePrinter, setSeparatePrinter] = useState(false);
  const [separateShop, setSeparateShop] = useState(false);
  const [buildingName, setBuildingName] = useState("");
  const [numOfUnit, setNumOfUnit] = useState("");
  const [setupFeeBeforeDiscount, setSetupFeeBeforeDiscount] = useState("");
  const [setupFee, setSetupFee] = useState("");
  const [serviceFee, setServiceFee] = useState("");
  const [serviceFeeBeforeDiscount, setServiceFeeBeforeDiscount] = useState("");
  const columnIndexPress = useRef();
  const rideIndexPress = useRef();
  const pdfRef = React.createRef();
  const [removeMonitor, setRemoveMonitor] = useState(false);
  const [PDFMode, setPDFMode] = useState(false);
  const [monitor, setMonitor] = useState();
  const [enableCarpentry] = useState(false);
  const { currentIdx, setCurrentIdx, setCurrentLocation } =
    useRideUnitContext();

  const [size, setSize] = useState(0);
  const addSetItemsCount = ({ ride, newColumns }) => {
    ride = ride.map((item) => item.items);
    const newItems = {};

    [...Object.values(ride), ...newColumns].map((e) =>
      e
        .filter((el) => el)
        .map(
          (i) =>
            (newItems[i.id] = {
              count: (newItems[i.id]?.count || 0) + (i.countInUnit || 1),
              item: i,
            })
        )
    );
    delete newItems.undefined;

    setItemsCount(newItems);
  };

  usePopulateRides({
    location,
    items,
    typeOfProperty,
    typeOfTemplate,
    templates,
    setColumns,
    setRideItems,
    columns,
    addSetItemsCount,
  });

  usePopulateItems({
    location,
    typeOfProperty,
    typeOfTemplate,
    items,
    columns,
    shop,
    rideItems,
    setColumns,
    addSetItemsCount,
  });

  const handleOpen = (type) => {
    setOpen(type || "unit");
  };

  const handleClose = () => {
    setOpen(null);
  };

  const onRemovePress = ({ columnIndex, index }) => {
    const newColumns = [...columns];
    newColumns[columnIndex].splice(index, 1);
    setColumns(newColumns);
    addSetItemsCount({ ride: rideItems, newColumns });
  };

  const onRideRemovePress = (index, unitIdx) => {
    const newRideItems = [...rideItems];
    newRideItems[unitIdx].items.splice(index, 1);
    setRideItems(newRideItems);
    addSetItemsCount({ ride: newRideItems, newColumns: columns });
  };

  const onAddRidePress = (index, type, unitIdx) => {
    setLink(null);
    setSize(0);
    setCurrentIdx(unitIdx);
    rideIndexPress.current = index;
    handleOpen(type);
  };

  const onUpPress = ({ columnIndex, index }) => {
    const newColumns = [...columns];
    const element = newColumns[columnIndex][index - 1];
    newColumns[columnIndex].splice(index - 1, 1);
    newColumns[columnIndex].splice(index, 0, element);
    setColumns(newColumns);
  };

  const onDownPress = ({ columnIndex, index }) => {
    const newColumns = [...columns];
    const element = newColumns[columnIndex][index + 1];
    newColumns[columnIndex].splice(index + 1, 1);
    newColumns[columnIndex].splice(index, 0, element);
    setColumns(newColumns);
  };

  const onAddItemPress = ({ size: newSize, columnIndex }) => {
    setLink(null);
    setSize(newSize);
    columnIndexPress.current = columnIndex;
    handleOpen("unit");
  };

  const onRemoveColumnPress = ({ columnIndex }) => {
    const newColumns = [...columns];
    newColumns.splice(columnIndex, 1);
    setColumns(newColumns);
  };

  const onSaveProposal = saveProposal(
    setLink,
    buildingName,
    columns,
    rideItems,
    logoImage,
    roomSimulationImage,
    roomSimulationImageDesc,
    rideSimulationImage,
    rideSimulationImageDesc,
    colorUnit,
    typeOfProperty,
    typeOfTemplate,
    numOfUnit,
    setupFee,
    setupFeeBeforeDiscount,
    serviceFee,
    serviceFeeBeforeDiscount,
    ride,
    rent,
    shop,
    hideIntroduction,
    separatePrinter,
    separateShop,
    location,
    ownerRevenue,
    setPDFMode
  );

  const onCreateLinkPress = uploadProposal({
    setLink,
    buildingName,
    columns,
    rideItems,
    logoImage,
    roomSimulationImage,
    roomSimulationImageDesc,
    rideSimulationImage,
    rideSimulationImageDesc,
    colorUnit,
    typeOfProperty,
    typeOfTemplate,
    numOfUnit,
    setupFee,
    setupFeeBeforeDiscount,
    serviceFee,
    serviceFeeBeforeDiscount,
    ride,
    rent,
    shop,
    hideIntroduction,
    separatePrinter,
    separateShop,
    location,
    ownerRevenue,
    setPDFMode,
  });

  const snapshot = useSnapshot(proposal);

  React.useEffect(() => {
    if (snapshot.importBuildingName) {
      importDataLogic();
    }
    // Only triggers an import when a new building name arrives. importDataLogic
    // is recreated every render, so adding it would re-run the import on every
    // render, changing behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [snapshot.importBuildingName]);

  const importDataLogic = importFromFirebase(
    proposal.importBuildingName,
    setTypeOfProperty,
    setTypeOfTemplate,
    setBuildingName,
    setRoomSimulationImage,
    setRoomSimulationImageDesc,
    setRideSimulationImage,
    setRideSimulationImageDesc,
    setNumOfUnit,
    setSetupFee,
    setSetupFeeBeforeDiscount,
    setServiceFee,
    setServiceFeeBeforeDiscount,
    setLocation,
    setCurrentLocation,
    setLogoImage,
    setHideIntroduction,
    setRide,
    setOwnerRevenue,
    setColumns,
    setRideItems,
    addSetItemsCount
  );

  React.useEffect(() => {
    if (!columns) {
      return;
    }

    updateSumCosts(columns);
  }, [columns, itemsCount]);

  useExitPdfMode(PDFMode, setPDFMode, importDataLogic, buildingName);

  const onAddColumnPress = ({ columnIndex }) => {
    const newColumns = [...columns];
    newColumns.splice(columnIndex + 1, 0, []);
    setColumns(newColumns);
  };

  const onItemClick = (itemKey) => {
    if (open === "Scooter" || open === "Bicycle") {
      const newRideItems = rideItems;
      newRideItems[currentIdx].items.splice(
        rideIndexPress.current + 1,
        0,
        items[itemKey]
      );

      addSetItemsCount({ ride: newRideItems, newColumns: columns });
    } else {
      const newColumns = columns;

      newColumns[columnIndexPress.current].push(items[itemKey]);

      addSetItemsCount({ ride: rideItems, newColumns });
    }
    handleClose();
  };

  useHandleMonitor(columns, removeMonitor, setMonitor, setColumns, monitor);
  const showItems = columns && typeOfTemplate && typeOfProperty;

  return (
    <Wrapper>
      <div ref={unitWrapperRef} style={{ height: "100%" }}>
        {items ? (
          <WizardForm
            onSaveProposal={onSaveProposal}
            typeOfTemplate={typeOfTemplate}
            hideIntroduction={hideIntroduction}
            PDFMode={PDFMode}
            numOfUnit={numOfUnit}
            buildingName={buildingName}
            showItems={showItems}
            className={`className="animate__animated animate__fadeIn`}
            rent={rent}
            onChangeBuildingName={setBuildingName}
            onChangeNumOfUnit={setNumOfUnit}
            onChangeSetupFee={setSetupFee}
            onChangeServiceFee={setServiceFee}
            setRent={setRent}
            setPDFMode={setPDFMode}
            shop={shop}
            setShop={setShop}
            setHideIntroduction={setHideIntroduction}
            ride={ride}
            setRide={setRide}
            separateShop={separateShop}
            setSeparateShop={setSeparateShop}
            separatePrinter={separatePrinter}
            setSeparatePrinter={setSeparatePrinter}
            typeOfProperty={typeOfProperty}
            setTypeOfProperty={setTypeOfProperty}
            setTypeOfTemplate={setTypeOfTemplate}
            onCreateLinkPress={onCreateLinkPress}
            link={link}
            location={location}
            setLocation={setLocation}
            setRemoveMonitor={setRemoveMonitor}
            removeMonitor={removeMonitor}
            importDataLogic={importDataLogic}
            enableCarpentry={enableCarpentry}
            onLogoChange={setLogoImage}
            onRoomSimulationChange={setRoomSimulationImage}
            onColorClick={setColorUnit}
            onRideSimulationChange={setRideSimulationImage}
          />
        ) : (
          <span>Please wait</span>
        )}

        {!PDFMode && (
          <UnitFullWrapper
            style={{ pointerEvents: snapshot.proposalApproved && "none" }}
            className="animate__animated animate__fadeIn animate__delay-1s"
          >
            {showItems && rent && (
              <div ref={pdfRef}>
                <RoomUnit
                  location={location}
                  itemsCount={itemsCount}
                  columns={columns}
                  onRemoveColumnPress={onRemoveColumnPress}
                  onAddColumnPress={onAddColumnPress}
                  onAddItemPress={onAddItemPress}
                  onRemovePress={onRemovePress}
                  onUpPress={onUpPress}
                  onDownPress={onDownPress}
                  showAddColumnOnHover={showAddColumnOnHover}
                  setShowAddColumnOnHover={setShowAddColumnOnHover}
                  colorUnit={colorUnit}
                  logoImage={logoImage}
                />
              </div>
            )}

            {showItems && rent && (
              <div
                style={{
                  marginTop: 100,
                  transform: "scale(0.8)",
                  transformOrigin: "left top",
                  marginBottom: -250,
                }}
              >
                <RoomUnit
                  location={location}
                  isDraw
                  itemsCount={itemsCount}
                  columns={columns}
                  colorUnit={colorUnit}
                  logoImage={logoImage}
                />
              </div>
            )}

            {/* todo: map all ride units
          add another type for bicycles
          add unit button by type
         */}

            {showItems && ride && (
              <RideUnits setRideItems={setRideItems}>
                {/* {currentIdx} */}
                {rideItems.map((item, index) => {
                  return (
                    <RideUnit
                      key={item.index}
                      rideItems={rideItems}
                      setRideItems={setRideItems}
                      type={item.type}
                      itemsCount={itemsCount}
                      location={location}
                      unitIdx={index}
                      onRemovePress={onRideRemovePress}
                      onAddRidePress={onAddRidePress}
                      ride={item}
                    />
                  );
                })}
              </RideUnits>
            )}

            {ride && rideItems?.length > 0 && (
              <>
                <RidePlans
                  rideItems={rideItems.filter(
                    (item) => item.type === "scooter"
                  )}
                  location={location}
                  type="scooter"
                />
                <RidePlans
                  rideItems={rideItems.filter(
                    (item) => item.type === "bicycle"
                  )}
                  location={location}
                  type="bicycle"
                />
              </>
            )}

            {roomSimulationImage && (
              <RemoveButton onClick={() => setRoomSimulationImage(null)}>
                Remove image
              </RemoveButton>
            )}

            {roomSimulationImage && (
              <Input
                value={roomSimulationImageDesc}
                style={{ width: "500px" }}
                type="text"
                placeholder="Description"
                name="Description"
                onChange={(event) =>
                  setRoomSimulationImageDesc(event.target.value)
                }
              />
            )}

            {roomSimulationImage && (
              <Img src={roomSimulationImage} height={500} />
            )}

            {rideSimulationImage && (
              <RemoveButton onClick={() => setRideSimulationImage(null)}>
                Remove Ride image
              </RemoveButton>
            )}

            {rideSimulationImage && (
              <Input
                value={rideSimulationImageDesc}
                style={{ width: "500px" }}
                type="text"
                placeholder="Description"
                name="Description"
                onChange={(event) =>
                  setRideSimulationImageDesc(event.target.value)
                }
              />
            )}

            {rideSimulationImage && (
              <Img src={rideSimulationImage} height={500} />
            )}
          </UnitFullWrapper>
        )}
      </div>

      {!PDFMode && (
        <AddItemToUnit
          size={size}
          location={location}
          onItemClick={onItemClick}
          items={items}
          handleClose={handleClose}
          open={open}
        />
      )}
      {PDFMode && (
        <div style={{ display: "none" }}>
          {" "}
          <PDF id={buildingName} setPDFMode={setPDFMode} setLink={setLink} />
        </div>
      )}
    </Wrapper>
    /* </Login> */
  );
};

const Wrapper = styled.div``;
const UnitFullWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  //transform: scale(0.9)
`;

const Img = styled.img`
  object-fit: contain;
`;

const RemoveButton = styled.a`
  background-color: #050505;
  border: none;
  color: white;
  padding: 10px 32px;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
  cursor: pointer;
  position: relative;
  width: fit-content;
  border-radius: 4px;
  align-self: center;
  margin-bottom: 5px;

  &:hover {
    color: white;
  }
`;

const Input = styled.input`
  color: #707070;
  padding: 10px;
  width: 100%;
  font-family: Manrope, serif;
  border: 1px solid #707070;

  &::-webkit-input-placeholder {
    padding-left: 0.25em;
  }
`;

/* const ImportWrapper = styled.a`
	display: flex;
	padding-top: 60px;
	align-items: flex-start;
	justify-content: center;
`; 

const ImportButton = styled.a`
	background-color: #050505;
	border: none;
	color: white;
	padding: 11px 22px;
	text-align: center;
	text-decoration: none;
	font-size: 16px;
	cursor: pointer;
	position: relative;
	width: fit-content;
	border-radius: 4px;
	align-self: flex-end;
	margin-left: 10px;
	opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};

	&:hover {
		color: white;
	}
`;*/

export { CreateUnitPageForm };

const mapStateToProps = ({ ItemsReducer }) => {
  return {
    items: ItemsReducer.items,
    templates: ItemsReducer.templates,
  };
};
